<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import DoubleRightChevron from "../../components/icons/DoubleRightChevron.svelte";

	import ReturnedRegistrationList from "./components/ReturnedRegistrationList.svelte";

	export let pageTitle = null;
	export let lastVisitedPage = null;
	export let disabled = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		//  Get the user Agent
		$model.UserAgent = navigator.userAgent;
		$model.referrer = document.referrer;
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		buttons.blockNext();
		await registerFormStart();

		buttons.next();
		buttons.unblock();
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h1 class="text-center">
					Finish your Registration for the {@html projectSettings.classActionName} Settlement
				</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					You have registered with Shine Lawyers before and your registrations are listed below. We need some
					other information to finish your registrations so you can be considered for compensation money from
					the settlement.
				</p>
				<p>
					To finish your registrations, please click on the orange button for <u>each</u> registration below
					and add as much information as you can for <u>each</u> registration.
				</p>

				<ReturnedRegistrationList landingPage />

				<FormRow class="justify-content-md-center confirmation-hide">
					<FormColumn>
						<p>
							If you need help to finish your registration <u
								>or if you need to make any other registrations</u
							>, please contact Shine Lawyers on
							<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
							<ClassActionEmailAddress></ClassActionEmailAddress>.
						</p>
					</FormColumn>
				</FormRow>

				<p>You can register one or more of the following types of claims:</p>
				<ol>
					<li>
						<strong>Claim For Yourself:</strong> You are an Aboriginal or Torres Strait Islander person who
						worked in the Northern Territory between 1 June 1933 and 12 November 1971 for little or no
						wages.
						<div class="subtext">
							<DoubleRightChevron size="24px" colour="#ff4814"></DoubleRightChevron> Complete Part 3 of this
							form.
						</div>
					</li>
					<li>
						<strong>Claim For Your Spouse (husband/wife/partner - married or defacto) Claim:</strong> Your
						spouse was an Aboriginal or Torres Strait Island person who worked in the Northern Territory
						between 1 June 1933 and 12 November 1971 for little or no wages and has passed away.
						<div class="subtext">
							<DoubleRightChevron size="24px" colour="#ff4814"></DoubleRightChevron> Complete Part 4 of this
							form.
						</div>
					</li>
					<li>
						<strong>Claim For Your Parent:</strong> Your mother, father or person who adopted you (either
						legally or under Aboriginal custom) was an Aboriginal or Torres Strait Islander person who
						worked in the Northern Territory between 1 June 1933 and 12 November 1971 for little or no wages
						but has passed away.
						<div class="subtext">
							<DoubleRightChevron size="24px" colour="#ff4814"></DoubleRightChevron> Complete Part 5 of this
							form.
						</div>
					</li>
				</ol>
				<p style="font-weight: 700">
					YOU SHOULD REGISTER ALL THE CLAIMS THAT YOU ARE ELIGIBLE TO MAKE. This may mean that you complete
					more than one claim. For example, you may complete a Claim For Yourself, a Claim For Your Spouse for
					your deceased spouse, and a Claim For Your Parent for each of your deceased parents.
				</p>
				<p>
					If you don't know the answer to any of the questions in this form you should keep going and send it
					to us with as many questions answered as you can. We will call you if we need more information. You
					might also be asked for more information later by the independent administrator.
				</p>
				<p>
					<strong>Last Date for Registration</strong><br />
					You must register by completing and signing the Registration Form, and returning it to Shine Lawyers
					in any of the above ways by 31 August 2025. If you are posting your completed Registration Form and supporting
					documents to Shine Lawyers, you will need to post these documents before this date so they are received
					by Shine Lawyers by 31 August 2025. You must complete and sign your registration by 31 August 2025 to
					be considered to receive compensation. If you need assistance, please contact Shine Lawyers as soon as
					possible.
				</p>
				<p>
					<strong>Support Services</strong><br />
					We know that completing this Registration Form might be difficult for you. Shine Lawyers cannot give
					you counselling or crisis support, but we encourage you to contact the following organisations for support
					(24 hours a day, 7 days a week):
				</p>
				<ul>
					<li>13YARN (specifically for Aboriginal and Torres Strait Islander peoples): call 13 92 76</li>
					<li>Lifeline: call 13 11 14</li>
					<li>Beyond Blue: call 1300 224 636</li>
					<li>NT Mental Health Line: 1800 682 288</li>
					<li>MensLine Australia (for men only): 1300 789 978</li>
				</ul>
				<p class="bold">If your life is in immediate danger, call 000.</p>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	ol {
		padding-left: 1.5rem;
		counter-reset: item;
		list-style-type: none;
	}

	ol li {
		padding: 20px;
		padding-left: 2.8rem;
		padding-bottom: 1rem;
		counter-increment: item;
		position: relative;
		border: solid 1px var(--color-soft);
		border-radius: 0.6rem;
		margin-left: -1.5rem;
		margin-bottom: 1rem;
		background-color: aliceblue;
	}

	ol li::before {
		content: counter(item);
		position: absolute;
		left: 0.5rem;
		width: 1.5rem;
		height: 1.5rem;
		text-align: center;
		background-color: var(--color-primary);
		font-weight: bold;
		border: 1px solid var(--color-primary);
		border-radius: 50%;
		color: #fff;
	}

	ol li .subtext {
		color: var(--color-primary);
	}
</style>
